"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DimensionCalculator_1 = require("./DimensionCalculator");
Object.defineProperty(exports, "calculateHeight", { enumerable: true, get: function () { return DimensionCalculator_1.calculateHeight; } });
Object.defineProperty(exports, "calculateWidth", { enumerable: true, get: function () { return DimensionCalculator_1.calculateWidth; } });
//# sourceMappingURL=index.js.map